import React, { FC, useMemo } from 'react';
import { QccBangDanTable } from './QccBangDanTable';
import { QccHonorList } from './QccHonorList';

export interface QccSectionProps {
  formDetail?: any;
  className?: string;
}

export const QccSection: FC<QccSectionProps> = ({ formDetail, className }) => {
  const bangDanList: any[] = useMemo(
    () => formDetail?.vendorQccBangDanInfos ?? [],
    [formDetail?.vendorQccBangDanInfos],
  );
  const honorCount = formDetail?.vendorQccHonorQualifications?.length ?? 0;

  return (
    <div className={className}>
      <QccBangDanTable list={bangDanList} />
      <QccHonorList count={honorCount} />
    </div>
  );
};
